export const LOADING_TEXT = 'Loading...'
export const REDIRECT_TO_DASHBOARD = '< Dashboard'
export const NO_DATA_FOUND_TX = 'No training data found.'
export const TITLE = 'Training Progress Report'
export const TRAINING_DESCRIPTION =
  'Training is designed for lesson instructors and staff with 0-1 year of experience using the Second Step® program.'
